import { ToastService } from './../util/toast.service';
import { CoinsProvider } from './../coins/coins';
import { Coin } from './../../models/Coin';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/last'
import { SettingsProvider } from './../settings/settings';
import { AuthProvider } from './../auth/auth';
import { Injectable } from '@angular/core';

/*
  Generated class for the WatchlistProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WatchlistProvider {

  constructor(
    private auth: AuthProvider,
    private settings: SettingsProvider,
    private CP: CoinsProvider,
    private toast: ToastService
  ) {
  }

  public isAuthenticated(){
    return this.auth.authenticated;
  }

  private getWatchlist(): Observable<string[]>{
    return this.settings.getUserSettings()
      .map(settings => {
        let watchlist: string[] = [];
        if(settings && settings.watchlist != null){
          watchlist = settings.watchlist;
        }
        return watchlist;
      });
  }

  public getWatchlistCoins(): Observable<Coin[]>{
    return this.getWatchlist()
      .flatMap(list => {
        return this.CP.getCoinsByName(list);
      })
  }

  public setWatchList(coins: Coin[]): void{
    let set = {'watchlist': coins.map(coin => coin.Name)};
    let sub = this.settings.setUserSettings(set)
      .subscribe(
        () => {sub.unsubscribe},
        (error) => {console.log(error)}
    )
  }

  public add(coin: Coin): void{
    if(!this.auth.authenticated){
      this.toast.create('Please sign in to create a watchlist', true, 2000);
      return;
    }
    this.getWatchlistCoins().first()
      .subscribe(list => {
        if(list){
          list.push(coin);
        }else{
          list = [coin];
        }
        this.setWatchList(list);
      }, error => { console.log(error) });
  }

  public remove(coin: Coin): void{
    this.getWatchlistCoins().first()
      .subscribe(list => {
        if(list){
          list = list.filter(c => c.Name != coin.Name);
          this.setWatchList(list);
        }
      }, error => { console.log(error) });
  }

  public coinInList(coin: Coin): Observable<boolean>{
    return this.getWatchlistCoins().map(coins => {
      if(coins){
        return coins.filter(c => c.Name == coin.Name).length >= 1;
      }
      return false;
    })
  }


}



// WEBPACK FOOTER //
// ./src/providers/watchlist/watchlist.ts